<template>
  <sfs-form-modal
    :id="modalId"
    title="Add a Recurring Payment"
    @on-hide="resetFormData"
  >
    <recurring-payment-form
      :technician-payment-id="technicianPaymentId"
      @on-submit="create"
      @on-save="onSave"
      @on-cancel="closeModal"
      :key="formKey"
      :user_id="userId"
    />
  </sfs-form-modal>
</template>

<script>
import RecurringPaymentForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';

export default {
  name: 'RecurringPaymentAddModal',
  mixins: [formModalMixin],
  components: {
    RecurringPaymentForm,
  },
  props: {
    technicianPaymentId: Number,
    userId: Number,
  },
  data() {
    return {
      modalId: 'recurring-payment-add-modal',
    };
  },
  methods: {
    create(data, handleCreate) {
      handleCreate(this.$recurringPaymentsAPI.create(this.userId, data));
    },
    onSave() {
      this.closeModal();
      this.resetFormData();
      this.$emit('on-save');
    },
  },
};
</script>
